import router from "@/router";

export function useRouteHopping<T>(path: string, query?: T) {
  router.push({
    path,
    query: query ? { ...query } : {},
  });
}

export function useRouteParam<T>(name: string, params?: T) {
  router.push({
    name,
    params: params ? { ...params } : {},
  });
}
